import { Box, Text } from '@chakra-ui/react';

export const getMessageOnDownloadPDF = (
  hasInstagramPlatformConnected,
  mediaPackHasInstagram,
) => {
  if (!hasInstagramPlatformConnected) {
    return {
      header: 'Connect Instagram to download your PDF',
      body: "To connect platforms go to Edit Media Pack > Name & Platforms. TikTok and YouTube only PDF's coming soon.",
    };
  }

  if (mediaPackHasInstagram) {
    return null;
  }

  return {
    header: 'Include Instagram in this media pack to download your PDF.',
    body: "To add Instagram go to Edit Media Pack > Name & Platforms. TikTok and YouTube only PDF's coming soon.",
  };
};

export const formatToolTipMessage = (
  hasInstagramPlatformConnected,
  mediaPackHasInstagram,
) => {
  const message = getMessageOnDownloadPDF(
    hasInstagramPlatformConnected,
    mediaPackHasInstagram,
  );

  if (!message) {
    return null;
  }

  return (
    <Box width="300px" color="black" padding={3}>
      <Text align={'center'} fontSize="md" fontWeight={500}>
        {message.header}
      </Text>
      <Text align={'center'} fontSize="md" fontWeight={400}>
        {message.body}
      </Text>
    </Box>
  );
};
